import { render, staticRenderFns } from "./MaintainScoreTask.vue?vue&type=template&id=9ed51116&scoped=true"
import script from "./MaintainScoreTask.vue?vue&type=script&lang=js"
export * from "./MaintainScoreTask.vue?vue&type=script&lang=js"
import style0 from "./MaintainScoreTask.vue?vue&type=style&index=0&id=9ed51116&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed51116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ed51116')) {
      api.createRecord('9ed51116', component.options)
    } else {
      api.reload('9ed51116', component.options)
    }
    module.hot.accept("./MaintainScoreTask.vue?vue&type=template&id=9ed51116&scoped=true", function () {
      api.rerender('9ed51116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/MaintainScoreTask.vue"
export default component.exports